import React from 'react';

const About = () => {
  return (
    <section className="about-section-three pt-0">
      <div className="anim-icons">
        <span className="icon icon-object-1"></span>
        <span className="icon icon-object-4"></span>
      </div>
      <div className="auto-container">
        <div className="row">
          {/* Content Column */}
          <div
            className="content-column col-xl-6 col-lg-7 col-md-12 col-sm-12 order-2 wow fadeInRight"
            data-wow-delay="600ms"
          >
            <div className="inner-column">
              <div className="sec-title">
                <span className="sub-title">About our company</span>
                <h2>Göçmenlik Sürecinde Baştan Sona Yanınızdayız.</h2>
                <div className="text">
                  There are many variations of passages of available but the majority have suffered alteration in some form, by injected hum randomised words which don't slightly.
                </div>
                <ul className="list-style-three">
                  <li>Lorem Ipsum is not simply random text</li>
                  <li>Making this the first true generator on the Internet.</li>
                </ul>
              </div>

              <div className="content-box">
                <div className="info-box">
                  <i className="icon flaticon-cooperation"></i>
                  <h6 className="title">Müşterilerin Güvendiği</h6>
                </div>
                <h5 className="title">7/24 Destek</h5>
                <div className="text">Lorem ipsum is simply velit anod ipas aliquet enean quis.</div>
                <a className="theme-btn btn-style-one" href="page-about.html">
                  <span className="btn-title">Şimdi Keşfet</span>
                </a>
              </div>
            </div>
          </div>

          {/* Image Column */}
          <div className="image-column col-xl-6 col-lg-5 col-md-12 col-sm-12">
            <div className="inner-column wow fadeInLeft">
              <span className="icon-dots bounce-y"></span>
              <figure className="image-1 overlay-anim wow fadeInUp">
                <img src="/assets/images/resource/about-4.jpg" alt="About 4" />
              </figure>
              <figure className="image-2 overlay-anim wow fadeInRight">
                <img src="/assets/images/resource/about-5.jpg" alt="About 5" />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;